import { Loader, PageLayout, Tabs } from '@bharatpe/bharat-ui';
import React, { useEffect, useRef, useState } from 'react';
import { getPendingRequest, TriggerNativeApiWrapper } from 'utils/nativeUpiHandler';
import { API_URL } from 'Services/CONSTANT';
import AppHeader from 'components/atoms/AppHeader';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import './styles.scss';
import { ICollectRequest, ICollectRequestDetails, IPaymentRequestData } from 'types';
import PendingTab from './PendingTab';
import CompletedTab from './CompletedTab';
import history from 'utils/History';

const ApproveToPay: React.FC = () => {
	const [loading, setLoading] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const prevScrollPRY = useRef(0);
	const prevScrollCRY = useRef(0);
	const [pendingLoading, setPendingLoading] = useState<boolean>(false);
	const [completedLoading, setCompletedLoading] = useState<boolean>(false);
	const [errMessage, setErrMessage] = useState<string>('');
	const [pendingRequest, setPendingRequest] = useState<Array<ICollectRequestDetails>>();
	const [paymentCompleted, setPaymentCompleted] = useState<Array<ICollectRequestDetails>>();
	const [paymentRequestData, setPaymentRequestData] = useState<IPaymentRequestData>({
		scrollY: 0,
		scrollPosition: 100,
		page_no: 0,
		total_pages: 1,
		page_size: 5,
	});

	const [completeRequestData, setCompleteRequestData] = useState<IPaymentRequestData>({
		scrollY: 0,
		scrollPosition: 100,
		page_no: 0,
		total_pages: 1,
		page_size: 5,
	});

	const getPaymentRequest = async (refresh: boolean) => {
		setPendingLoading(refresh);
		setErrMessage('');
		try {
			const requestList: ICollectRequest = await getPendingRequest({
				pageNo: refresh ? 0 : paymentRequestData?.page_no,
				pageSize: paymentRequestData?.page_size,
			});
			if (requestList) {
				setPaymentRequestData((prevPaymentRequestData) => {
					return {
						...prevPaymentRequestData,
						page_no: requestList?.page_no + 1,
						page_size: requestList?.page_size,
						total_pages: requestList?.total_pages,
					};
				});
				setPendingRequest([...(pendingRequest || []), ...requestList?.collect_transactions]);
				setPendingLoading(false);
			}
		} catch (err: any) {
			setErrMessage(err?.error || 'SOMETHING WENT WRONG');
			setPendingLoading(false);
		}
	};

	const getAllTransactionsList = async (refresh: boolean) => {
		setCompletedLoading(refresh);
		setErrMessage('');
		try {
			const requestList: any = await TriggerNativeApiWrapper(
				`${API_URL.all_transactions}?txn_type=COLLECT&txn_status=SUCCESS%2CCOLLECT_REJECTED%2CFAILED%2CCOLLECT_EXPIRED&more_than_15k=true`,
				'GET',
				{},
				{},
			);
			if (requestList) {
				setCompleteRequestData((prevCompleteRequestData) => {
					return {
						...prevCompleteRequestData,
						page_no: requestList?.page_no + 1,
						page_size: requestList?.page_size,
						total_pages: requestList?.total_pages,
					};
				});
				setPaymentCompleted([...(paymentCompleted || []), ...requestList?.user_transactions]);
				setCompletedLoading(false);
			}
		} catch (err: any) {
			setErrMessage(err?.error || 'SOMETHING WENT WRONG');
			setCompletedLoading(false);
		}
	};

	useEffect(() => {
		window.onscroll = () => {
			const currentScrollY = window.pageYOffset;
			setPaymentRequestData((prevPaymentRequestData) => {
				return { ...prevPaymentRequestData, scrollY: currentScrollY };
			});
			setCompleteRequestData((prevCompleteRequestData) => {
				return { ...prevCompleteRequestData, scrollY: currentScrollY };
			});
		};
	}, []);

	useEffect(() => {
		if (prevScrollPRY.current < paymentRequestData?.scrollY) {
			if (
				paymentRequestData?.scrollY > paymentRequestData?.scrollPosition &&
				paymentRequestData?.total_pages >= paymentRequestData?.page_no
			) {
				console.log('TEST3');
				setPaymentRequestData((prevPaymentRequestData) => {
					return { ...prevPaymentRequestData, scrollPosition: prevPaymentRequestData?.scrollPosition + 100 };
				});
				getPaymentRequest(false);
			}
		}
	}, [paymentRequestData.total_pages, paymentRequestData.scrollPosition, paymentRequestData?.scrollY]);

	useEffect(() => {
		if (prevScrollCRY.current < completeRequestData?.scrollY) {
			if (
				completeRequestData?.scrollY > completeRequestData?.scrollPosition &&
				completeRequestData?.total_pages >= completeRequestData?.page_no
			) {
				setCompleteRequestData((prevCompleteRequestData) => {
					return { ...prevCompleteRequestData, scrollPosition: prevCompleteRequestData?.scrollPosition + 100 };
				});
				getAllTransactionsList(false);
			}
		}
	}, [completeRequestData.total_pages, completeRequestData.scrollPosition, completeRequestData?.scrollY]);

	useEffect(() => {
		getPaymentRequest(true);
		getAllTransactionsList(true);
	}, []);

	const reloadTransactions = () => {
		getPaymentRequest(false);
	};

	const list = ['Pending', 'Completed'];

	const onTabChange = (index: number) => {
		setSelectedIndex(index);
	};

	const showMandateList = () => {
		if (selectedIndex == 0) {
			return (
				<PendingTab
					paymentRequestItem={pendingRequest}
					transactionLoading={pendingLoading}
					reloadTransactions={reloadTransactions}
				/>
			);
		}
		if (selectedIndex == 1) {
			return (
				<CompletedTab
					paymentRequestItem={paymentCompleted}
					transactionLoading={completedLoading}
					reloadTransactions={reloadTransactions}
				/>
			);
		}
	};

	const onBack = () => {
		history.push({ pathname: '/account/upi-settings' });
	};

	return loading || pendingLoading || completedLoading ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background ">
			<>
				<AppHeader title={'Approve to Pay'} leftIconAction={onBack} />
				<Tabs selected={selectedIndex} list={list} onSelect={onTabChange} />
				{showMandateList()}
				<div className="upi-powered-sticky">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};

export default ApproveToPay;
